import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Img from "@/components/img";
import { ProductModelDetails } from "@/services/productService";
import "./style.scss";

interface ModelDetailsProps {
  modelProfile: ProductModelDetails;
}

const ModelDetails: FC<ModelDetailsProps> = ({ modelProfile }) => {
  const { height, bust, waist, hips, imageUrl, modelSizeLabel } = modelProfile;
  const { t } = useTranslation("productDetails");

  const modelSizeAlt = t("model.modelSize", { modelSizeLabel, lng: "en" });

  return (
    <div className="model_info_block">
      <div className="image_block">
        <Img className="image" src={imageUrl} alt={modelSizeAlt} />
      </div>
      <div className="details_block">
        <span className="size_text">
          {t("model.modelSize", { modelSizeLabel })}
        </span>
        <div className="details_text_block">
          <span>{t("model.height", { height })}</span>
          <span>{t("model.bust", { bust })}</span>
          <span>{t("model.waist", { waist })}</span>
          <span>{t("model.hips", { hips })}</span>
        </div>
      </div>
    </div>
  );
};

export default ModelDetails;
